var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-input"},[_c('button',{on:{"click":_vm.subtract}},[_vm._v("-")]),_c('input',{class:{'is-invalid': _vm.state === false},attrs:{"type":"number"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateNumber($event.target.value)}}}),_c('button',{on:{"click":_vm.add}},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }